import React from 'react';

import * as PortfolioValues from './PortfolioValuesNew';
// import * as Benchmarks from './Benchmarks';
import * as AdditionalBenchmarks from './AdditionalBenchmarks';

// import * as AnalysisType from './AnalysisType';
import { Divider } from '@material-ui/core';

import styled from 'styled-components';


const KeepTogether = styled.div`
    margin-bottom: 40px; 

    @media print{
        page-break-inside:avoid;
    }
`; 

const Preview = (props) => { 

    const { portfolio } = props; 

    const steps = [
        PortfolioValues,
        // Benchmarks,
        AdditionalBenchmarks
    ];

    function getStepRow(Step) {
        return <KeepTogether>
            {Step.Title !== 'Portfolio Values' && <div style={{ fontSize: 20 }}>{Step.Title}</div>}
            {Step.Title !== 'Portfolio Values' && <Divider />}
            <div style={{ fontSize: 14, margin: 10, color: '#797878' }}><Step.Preview {...{ ...props, portfolio }} /></div>
        </KeepTogether>
    }
    return <div>

        {steps.map((e, i) => <div key={`ss3_${i}`}>
            {getStepRow(e)}
        </div>)}
    </div>
}

export default Preview;


// WEBPACK FOOTER //
// ./src/portfolioEntryWizard/components/Preview.js